import RestService from "./rest.service";

class competencyService {
  competency(data, employee_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getCompetency(data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  competencyYear(employee_id) {
    return new Promise((fnResolve, fnReject) => {
      if (employee_id !== undefined) {
        RestService.getCompetency(`app/kpi/kpi_form?type=competency&employee_id=${employee_id}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.getCompetency("app/kpi/kpi_form?type=competency").then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
      
    });
  }
  detailCompetency(serial,employee_id) {
    return new Promise((fnResolve, fnReject) => {
      if (employee_id !== undefined) {
        RestService.getDetailCompetency(`app/kpi/competency/${serial}?employee_id=`+employee_id).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.getDetailCompetency(`app/kpi/competency/${serial}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    });
  }
}

export default new competencyService();
